import { ChatPageWrapper } from "@mirage/mosaics/Chat/components/layouts/ChatPageLayout";
import { AssistTemplatesContextProvider } from "@mirage/mosaics/ComposeAssistant/data/AssistTemplatesContext";
import { ComposeAnalyticsContextProvider } from "@mirage/mosaics/ComposeAssistant/data/ComposeAnalyticsContext";
import { ComposeVoicesContextProvider } from "@mirage/mosaics/ComposeAssistant/data/ComposeVoicesContext";
import { memo } from "react";
import { ConversationAssistantPageContent } from "./ConversationAssistantPageContent";

import type { ChatSource } from "@mirage/mosaics/Chat/types";
import { SourcesCacheProvider } from "@mirage/mosaics/ComposeAssistant/components/workflow-agent/SourcesCacheContext";
import { ComposeSessionsContextProvider } from "@mirage/mosaics/ComposeAssistant/data/ComposeSessionsContext";
import { ComposeCurrentSessionContextProvider } from "@mirage/mosaics/ComposeAssistant/data/current-session/ComposeCurrentSessionContext";
import { useDashTitle } from "@mirage/shared/hooks/DashTitle";
import i18n from "@mirage/translations";

export interface ConversationAssistantLocationState {
  providedSources: ChatSource[];
}

export const ConversationAssistantPage = memo(() => {
  useDashTitle(i18n.t("chat"));
  return (
    // This ComposeSessionsContextProvider is only used for legacy sessions.
    // It will be removed once we no longer want to show legacy sessions.
    // Do not use this for new session management.
    <ComposeSessionsContextProvider>
      <ComposeAnalyticsContextProvider>
        <ComposeVoicesContextProvider>
          <AssistTemplatesContextProvider>
            <ChatPageWrapper>
              <ComposeCurrentSessionContextProvider>
                <SourcesCacheProvider>
                  <ConversationAssistantPageContent />
                </SourcesCacheProvider>
              </ComposeCurrentSessionContextProvider>
            </ChatPageWrapper>
          </AssistTemplatesContextProvider>
        </ComposeVoicesContextProvider>
      </ComposeAnalyticsContextProvider>
    </ComposeSessionsContextProvider>
  );
});
ConversationAssistantPage.displayName = "ConversationAssistantPage";
